import React, { useState } from 'react';
import PaymentPlanSection from './PaymentPlanSection';

/**
 * El plan de pagos plegado, para la revisión IA. No se monta hasta que se
 * abre: así revisar un caso no pide el plan de cada expediente que pasa.
 */
const PaymentPlanCollapsible = ({ expedientId, debt, onStateChange }) => {
  const [abierto, setAbierto] = useState(false);
  return (
    <details className='mt-4 border-t border-slate-100 pt-3' onToggle={e => setAbierto(e.currentTarget.open)}>
      <summary className='text-sm font-medium text-slate-700 cursor-pointer'>Plan de pagos</summary>
      {abierto && (
        <div className='mt-3'>
          <PaymentPlanSection expedientId={expedientId} debt={debt} onStateChange={onStateChange} />
        </div>
      )}
    </details>
  );
};

export default PaymentPlanCollapsible;
